<template>
	<div>
		<p-card class=" guideline-job-list">
			<div class="tw-flex tw-justify-between tw-items-center tw-mb-3">
				<div class="tw-flex tw-items-center tw-gap-4">
					<label :style="`color:${$appColors.info}`">
						Ordenar:
						<v-select
							:items="filters"
							:menu-props="{ contentClass: 'type-select-content' }"
							class="select-core"
							hide-details
							height="17"
							outline
							single-line
							item-text="name"
							item-value="id"
							return-object
							v-model="selectedItem"
							@input="filterJobsInList"/>
					</label>
					<p-notification-bell
						:icon="incompleteJobsCount > 0 ? 'notifications_active' : 'notifications'"
						:icon-color="incompleteJobsCount > 0 ? $appColors.warning : $appColors.success"
						:count="incompleteJobsCount > 0 ? incompleteJobsCount : jobList.length"
						:tooltip-text="incompleteJobsCount > 0 ? `${incompleteJobsCount} sin configurar` : `${jobList.length} puestos configurados`"
						:badge-color="incompleteJobsCount > 0 ? 'warning' : 'success'"
						@click="openIncompleteJobsModal" />
				</div>
				<selector-active-job
					:index-tab="indexTab"
					@filterJobByStatus="$emit('filterJobByStatus', $event)">
				</selector-active-job>
			</div>
			<template v-if="jobList.length < 1">
				<div class="empty-list tw-flex tw-justify-center tw-items-center tw-w-full">
					<div class="empty-job-card tw-w-1/2 lg:tw-w-1/3 2xl:tw-w-1/5"></div>
					<p class="tw-text-center">{{ emptyMessage }}</p>
				</div>
			</template>
			<template v-if="jobList.length > 0">
				<div class="tw-flex tw-flex-wrap tw--mx-2">
					<div
						v-for="(job) in jobList"
						:key="job.name"
						class="tw-w-1/2 lg:tw-w-1/3 2xl:tw-w-1/5 tw-px-2 tw-mb-4"
					>
						<c-model-job-item
							:job="job"
							:index-tab="indexTab"
							:completed="job.completed"
							:selected="selectedJob.name === job.name"
							@deleteClick="$emit('deleteClick', $event)"
							@descriptionClick="$emit('descriptionClick', $event)"
							@onChangeStatus="$emit('onChangeStatus', $event)"
							@viewPdfClick="$emit('viewPdfClick', $event)"
							@editionClick="$emit('editionClick', $event)"
						/>
					</div>
				</div>
			</template>
		</p-card>
		
		<!-- Modal para mostrar puestos incompletos -->
		<incomplete-jobs-modal
			ref="incompleteJobsModal"
			:job-list="jobList" />
	</div>
</template>

<script>
import cModelJobItem from '@/modules/job-profile/components/jobs-profile/model-job-item';
import selectorActiveJob from '@/modules/job-profile/components/jobs-profile/job-info-edition/selector-active-job';
import IncompleteJobsModal from '@/modules/job-profile/components/jobs-profile/incomplete-jobs-modal';
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PButton from '@/modules/shared/components/ui/p-button';
import { verifyJobIsCompleted } from '@/modules/job-profile/helpers/helpers';

export default {
	name: 'job-list',
	data() {
		return {
			selectedItem: null,
			filters: [
				{
					id: 1,
					name: 'Ascendente',
					code: 'ASC',
					value: 'ASC',
				},
				{
					id: 2,
					name: 'Descendente',
					code: 'DESC',
					value: 'DESC',
				},
			],
		};
	},
	created() {
		this.selectedItem = this.filters[0];
	},
	mounted() {
		this.filterJobsInList();
	},
	methods: {
		filterJobsInList() {
			if (this.selectedItem.code === 'ASC') {
				this.jobList.sort((a, b) => a.name.localeCompare(b.name));
			} else {
				this.jobList.sort((a, b) => b.name.localeCompare(a.name));
			}
		},
		openIncompleteJobsModal() {
			this.$refs.incompleteJobsModal.open();
		},
	},
	components: { PCard, cModelJobItem, selectorActiveJob, PButton, IncompleteJobsModal },
	props: ['jobList', 'selectedJob', 'indexTab'],
	computed: {
		emptyMessage() {
			if (this.indexTab === 1) {
				return 'No hay puestos inactivos';
			}
			return 'Agrega todos los puestos de trabajo de tu empresa';
		},
		incompleteJobsCount() {
			if (!this.jobList || this.jobList.length === 0) return 0;
			return this.jobList.filter(job => !verifyJobIsCompleted(job)).length;
		},
	},
	watch: {
		jobList: {
			handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.filterJobsInList();
				}
			},
		},
	},
};
</script>

<style lang='scss' scoped>
 .guideline-job-list {
	 min-height: auto;
	 .empty-list {
		 position: relative;
		 min-height: 450px;
		 .empty-job-card {
			 position: absolute;
			 padding: inherit;
			 top: 0;
			 left: 0;
			 height: 30%;
			 border: 2px dashed #9b9b9b;
			 border-radius: 10px;
		 }
		 p {
			 text-transform: uppercase;
			 color: #9b9b9b;
			 width: 200px;
		 }
	 }
 }
</style>



// WEBPACK FOOTER //
// src/modules/job-profile/components/jobs-profile/job-list.vue